
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"45","height":"45","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"empty_video","d":"M3.75 41.25h37.5V3.75H3.75v37.5zm0 3.75C1.683 45 0 43.444 0 41.53V3.473C0 1.556 1.683 0 3.75 0h37.5C43.317 0 45 1.556 45 3.474v38.055C45 43.444 43.317 45 41.25 45H3.75zm0-13.125h37.5a1.875 1.875 0 010 3.75H3.75a1.875 1.875 0 010-3.75zM15 11.092a2.812 2.812 0 014.333-2.366l10.454 6.72a2.811 2.811 0 010 4.732l-10.454 6.72A2.812 2.812 0 0115 24.533v-13.44zm3.75 11.724l7.783-5.003-7.783-5.004v10.007z"}})]),_c('use',{attrs:{"fill":"#C5CDE2","fill-rule":"nonzero","xlink:href":"#empty_video"}})])
          )
        }
      }
    